export default (element: Element): [string, FormDataEntryValue][] => {
  const form = element.closest('form')
  if (!form) return []

  const fd = new FormData(form)
  const entries = Array.from(fd.entries())
  return entries.filter(([k, _]) => k.includes("filter")).map(([k,v]) => [k.split(/[\[\]]/)[1], v])
}

